import $ from 'jquery';

const NEXT_ARROW = '<button class="carousel-control-next" type="button"><span class="carousel-control-next-icon" aria-hidden="true"></span></button>';
const PREV_ARROW = '<button class="carousel-control-prev" type="button"><span class="carousel-control-prev-icon" aria-hidden="true"></span></button>';

/**
 * Every Slick carousel of the site, keyed by the class the templates and the
 * page-builder sets use. Slick on an empty selection is a no-op, so each call
 * costs nothing on pages without that carousel.
 */
export function initSliders() {
    $('.slick-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20%',
        nextArrow: NEXT_ARROW,
        prevArrow: PREV_ARROW,
        responsive: [{
            breakpoint: 1200,
            settings: {
                centerPadding: '5%',
            },
        }],
    });

    $('.full-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: NEXT_ARROW,
        prevArrow: PREV_ARROW,
        autoplay: true,
        autoplaySpeed: 2000,
    });

    $('#mobilehome-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: false,
        nextArrow: NEXT_ARROW,
        prevArrow: PREV_ARROW,
        responsive: [
            {
                breakpoint: 768,
                arrows: false,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '30px',
                },
            },
            {
                breakpoint: 1200,
                arrows: false,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });

    $('.single-image-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
    });

    $('.slick-carousel').slick({
        infinite: true,
        slidesToShow: 5.5,
        slidesToScroll: 1,
        nextArrow: NEXT_ARROW,
        prevArrow: PREV_ARROW,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });

    $('.cards-property').slick({
        infinite: true,
        slidesToShow: 5.2,
        slidesToScroll: 1,
        nextArrow: NEXT_ARROW,
        prevArrow: PREV_ARROW,
        centerMode: true,
        centerPadding: '4vw',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4.2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: '10vw',
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.2,
                },
            },
        ],
    });

    $('.slick-carousel-full').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: NEXT_ARROW,
        prevArrow: PREV_ARROW,
    });

    // partner / news slider, homepage 2024
    $('.slick-slider-partners').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        adaptiveHeight: false,
    });

    $('.slick-slider-partners').on('setPosition', function () {
        $(this).find('.slick-slide').height('auto');
        var slickTrack = $(this).find('.slick-track');
        var slickTrackHeight = $(slickTrack).height();
        $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
    });

    // logos slider, page-builder set 2025
    $('.slick-slider-loghi').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    if ($('.areaCard').length > 0) {
        $('.areaCard').not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            nextArrow: NEXT_ARROW,
            prevArrow: PREV_ARROW,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    // Re-layout for a Chrome mobile rendering bug
    $('.areaCard').slick('refresh');
}
